import React from "react";
import styled from "styled-components";
import { CSS_BREAKPOINTS_MIN } from "../config/constants";

const RoundedImage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.alignItems ?? "center"};
  justify-content: flex-start;

  img {
    margin: 0 ${(props) => `${props.marginRight}`} 0 0;
    width: ${(props) => `${props.size}` ?? "96"}px;
    height: ${(props) => `${props.size}` ?? "96"}px;
    border-radius: ${(props) => `${props.size / 2}` ?? "48"}px;

    @media ${CSS_BREAKPOINTS_MIN.sm} {
      margin: 0 ${(props) => `${props.marginRight}`} 0 0;
      width: ${(props) => `${props.desktopSize}` ?? "96"}px;
      height: ${(props) => `${props.desktopSize}` ?? "96"}px;
      border-radius: ${(props) => `${props.desktopSize / 2}` ?? "48"}px;
    }
  }
`;

const Avatar = ({
  imageUrl,
  rightContent,
  avatarSize,
  desktopSize,
  ...rest
}) => {
  return (
    <RoundedImage {...rest} size={avatarSize} desktopSize={desktopSize}>
      <img src={imageUrl} alt={imageUrl} />
      {rightContent}
    </RoundedImage>
  );
};

export default Avatar;
